import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

export const IssuesTable = () => {
  const data = Array(5).fill('');

  return (
    <TableContainer>
      <Table
        sx={{
          '.MuiSkeleton-root': { display: 'inline-block', height: '23.75px' },
          'th .MuiSkeleton-root': { height: '17px' },
          'td, th': { verticalAlign: 'middle' },
          'tbody td': { borderBottomWidth: '2px' },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>
              <Skeleton variant="rectangular" width={50} />
            </TableCell>
            <TableCell width={150} align="right">
              <Skeleton variant="rectangular" width={60} />
            </TableCell>
            <TableCell width={125} align="right">
              <Skeleton variant="rectangular" width={60} />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((_, idx) => (
            <TableRow key={idx}>
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  <Skeleton variant="circular" width={20} height={20} sx={{ mr: 2 }} />
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Skeleton variant="rectangular" width={150} height={15} sx={{ mb: 0.5 }} />
                    <Skeleton variant="rectangular" width={250} height={15} />
                  </Box>
                </Box>
              </TableCell>
              <TableCell align="right">
                <Skeleton variant="rectangular" width={40} />
              </TableCell>
              <TableCell align="right">
                <Skeleton variant="rounded" width={80} height={30} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
